import format from 'date-fns/format';

export const Time = dateObj => format(dateObj, 'HH:mm');
export const Date = dateObj => format(dateObj, 'd MMM yyyy');
